import dayjs from "@/lib/dayjs";
/**
 * day1に対してday2が何日前かを返すので、day1がday2よりも未来の場合は正の数、過去の場合は負の数を返す
 * @example - getDiffDaysByDay("2024-12-31", "2024-12-29") // 2
 * @param day1 - dayjsで扱える日付
 * @param day2 - dayjsで扱える日付
 * @returns day1に対してday2が何日前か。day1がday2よりも未来の場合は正の数、過去の場合は負の数
 */
export const getDiffDaysByDay = (day1: string, day2: string): number => {
	const firstDay = dayjs(day1);
	const secondDay = dayjs(day2);

	return firstDay.diff(secondDay, "day");
};
